import { render, staticRenderFns } from "./SampleMemoryChemical.vue?vue&type=template&id=6fa94822&scoped=true"
import script from "./SampleMemoryChemical.vue?vue&type=script&lang=js"
export * from "./SampleMemoryChemical.vue?vue&type=script&lang=js"
import style0 from "./SampleMemoryChemical.vue?vue&type=style&index=0&id=6fa94822&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa94822",
  null
  
)

export default component.exports